import { jsx as _jsx } from "react/jsx-runtime";
const PiggyBankIcon = (props) => {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none" }, { children: _jsx("path", { d: "M19.83 7.5L17.56 5.23C17.63 4.81 17.74 4.42 17.88 4.08C17.96 3.9 18 3.71 18 3.5C18 2.67 17.33 2 16.5 2C14.86 2 13.41 2.79 12.5 4H7.5C4.46 4 2 6.46 2 9.5C2 12.54 4.5 21 4.5 21H10V19H12V21H17.5L19.18 15.41L22 14.47V7.5H19.83ZM13 9H8V7H13V9ZM16 11C15.45 11 15 10.55 15 10C15 9.45 15.45 9 16 9C16.55 9 17 9.45 17 10C17 10.55 16.55 11 16 11Z", fill: props.color }) })));
};
PiggyBankIcon.defaultProps = {
    color: '#6F82C0',
};
export default PiggyBankIcon;
